import React, {Component} from 'react'
import MaskedInput from 'react-text-mask';

class CpfInput extends Component{
    render(){
        return(
            <MaskedInput {...this.props} 
            mask={[/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/]} 
            />   
        )
    }
}

export default CpfInput


// WEBPACK FOOTER //
// ./src/inputs/CpfInput.js